var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.687,
    height: 14.082,
    viewBox: "0 0 10.687 14.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37609",
    "data-name": "Path 37609",
    d: "M9.4,6.791A3.4,3.4,0,1,0,6,3.4a3.4,3.4,0,0,0,3.4,3.4Zm0-5.659A2.264,2.264,0,1,1,7.132,3.4,2.264,2.264,0,0,1,9.4,1.132Z",
    transform: "translate(-4.302)",
    fill: "#ff643a",
    stroke: "#ff643a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37610",
    "data-name": "Path 37610",
    d: "M8.093,14A5.1,5.1,0,0,0,3,19.093a.566.566,0,1,0,1.132,0,3.961,3.961,0,0,1,7.923,0,.566.566,0,0,0,1.132,0A5.1,5.1,0,0,0,8.093,14Z",
    transform: "translate(-3 -6.077)",
    fill: "#ff643a",
    stroke: "#ff643a",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e4af31d7873d04a31eab6513ac609576.svg";
export { ForwardRef as ReactComponent };